export default [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "view2"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva negociacion",
    command: "new_deal"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva interaccion",
    command: "new_interaction"
  },
  {
    icon: "el-icon-plus",
    label: "Nueva solicitud",
    command: "new_request"
  },
  {
    icon: "el-icon-plus",
    label: "Crear contacto",
    command: "new_contact"
  },
  {
    icon: "el-icon-delete",
    label: "Eliminar Prospectos",
    command: "inact"
  }
];
